import { List } from '@yaradigitallabs/ahua-react';
import { SoftTagListItem, SoftTagListItemSkeleton } from './SoftTagListItem';
import type { SoftTag } from '../utils/match-maker.types';

interface SoftTagListProps {
  isLoading?: boolean;
  items?: SoftTag[];
  selectedIds?: string[];
  selectedCount?: number;
  maxSelectable?: number;
  onToggleSelect?: (item: SoftTag, checked: boolean) => void;
  onDetailSelect: (softTagId: string) => void;
}

export const SoftTagList = ({
  isLoading = false,
  items = [],
  selectedIds = [],
  selectedCount = 0,
  maxSelectable = 5,
  onToggleSelect,
  onDetailSelect,
}: SoftTagListProps) => {
  const maxReached = selectedCount >= maxSelectable;

  return (
    <div className="flex h-full w-full flex-col overflow-auto">
      <List>
        {isLoading &&
          Array.from({ length: 5 }).map((_, index) => (
            <SoftTagListItemSkeleton key={`soft_tag_loader_${index}`} />
          ))}
        {!isLoading &&
          items.map(item => (
            <SoftTagListItem
              key={item.timeseries_id}
              item={item}
              checked={selectedIds.includes(item.timeseries_id)}
              disabled={maxReached && !selectedIds.includes(item.timeseries_id)}
              onCheckedChange={onToggleSelect}
              onDetailSelect={onDetailSelect}
            />
          ))}
      </List>
    </div>
  );
};
